// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Chip,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   TextField,
//   Divider,
//   Tabs,
//   Tab,
//   Tooltip,
// } from "@mui/material";
// import { Edit, Visibility, Add, Delete } from "@mui/icons-material";
// import TableComponent from "../../Components/TableComponent/TableComponent";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import api from "../../api/axiosInterceptor";

// // ─── tiny tab-panel helper ────────────────────────────────────────────────────
// function TabPanel({ children, value, index }) {
//   return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
// }

// // ─── initial blank shapes ─────────────────────────────────────────────────────
// const blankDoc = () => ({ doc_name: "", doc: "" });
// const blankField = () => ({ field_name: "", field_particular: "" });

// export const AdminRoleManagementComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // snackbar
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   // edit dialog
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedRoleIds, setSelectedRoleIds] = useState([]);
//   const [designation, setDesignation] = useState("");
//   const [documents, setDocuments] = useState([blankDoc()]);
//   const [profileFields, setProfileFields] = useState([blankField()]);
//   const [editTab, setEditTab] = useState(0);

//   // view dialog
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [viewUser, setViewUser] = useState(null);
//   const [viewTab, setViewTab] = useState(0);

//   // ── columns ─────────────────────────────────────────────────────────────────
//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "name", field: "name", headerName: "Name", width: 200 },
//     { id: "email", field: "email", headerName: "Email", width: 250 },
//     {
//       id: "phone_number",
//       field: "phone_number",
//       headerName: "Phone Number",
//       width: 150,
//     },
//     {
//       id: "roles",
//       field: "roles",
//       headerName: "Roles",
//       width: 280,
//       renderCell: (params) => (
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//           {params.value.map((role) => (
//             <Chip key={role.id} label={role.name} size="small" />
//           ))}
//         </Box>
//       ),
//     },
//     {
//       id: "designation",
//       field: "designation",
//       headerName: "Designation",
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2">{params.value || "-"}</Typography>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 130,
//       renderCell: (params) => (
//         <Box>
//           <Tooltip title="View details">
//             <IconButton color="info" onClick={() => handleView(params.row)}>
//               <Visibility />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Edit">
//             <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//               <Edit />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   // ── data fetching ────────────────────────────────────────────────────────────
//   const fetchRoles = () => {
//     api
//       .get("/auth/roles/")
//       .then((res) => setRoles(res.data))
//       .catch(() => showSnack("Failed to load roles.", "error"));
//   };

//   const fetchRoleMgmt = () => {
//     setLoading(true);
//     api
//       .get("/auth/role-mgmt/")
//       .then((res) => {
//         const apiData = res.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           name: item.name,
//           email: item.email,
//           phone_number: item.phone_number,
//           roles: item.roles || [],
//           designation: item.profile?.designation || "",
//           documents: item.profile?.documents || [],
//           profileFields: item.profile?.profile_fields || [],
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         showSnack("Failed to load user roles.", "error");
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     fetchRoles();
//     fetchRoleMgmt();
//   }, []);

//   // ── helpers ──────────────────────────────────────────────────────────────────
//   const showSnack = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   // ── view ─────────────────────────────────────────────────────────────────────
//   const handleView = (user) => {
//     setViewUser(user);
//     setViewTab(0);
//     setOpenViewDialog(true);
//   };

//   // ── edit ─────────────────────────────────────────────────────────────────────
//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setSelectedRoleIds(user.roles.map((r) => r.id));
//     setDesignation(user.designation || "");
//     setDocuments(user.documents?.length ? user.documents : [blankDoc()]);
//     setProfileFields(
//       user.profileFields?.length ? user.profileFields : [blankField()],
//     );
//     setEditTab(0);
//     setOpenEditDialog(true);
//   };

//   // ── document list helpers ────────────────────────────────────────────────────
//   const handleDocChange = (index, field, value) => {
//     setDocuments((prev) =>
//       prev.map((d, i) => (i === index ? { ...d, [field]: value } : d)),
//     );
//   };
//   const addDoc = () => setDocuments((prev) => [...prev, blankDoc()]);
//   const removeDoc = (index) =>
//     setDocuments((prev) => prev.filter((_, i) => i !== index));

//   // file → base64
//   const handleDocFile = (index, file) => {
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (e) => handleDocChange(index, "doc", e.target.result);
//     reader.readAsDataURL(file);
//   };

//   // ── profile-field list helpers ───────────────────────────────────────────────
//   const handleFieldChange = (index, key, value) => {
//     setProfileFields((prev) =>
//       prev.map((f, i) => (i === index ? { ...f, [key]: value } : f)),
//     );
//   };
//   const addField = () => setProfileFields((prev) => [...prev, blankField()]);
//   const removeField = (index) =>
//     setProfileFields((prev) => prev.filter((_, i) => i !== index));

//   // ── update ───────────────────────────────────────────────────────────────────
//   const handleUpdate = () => {
//     if (!selectedUser) return;

//     const payload = {
//       roles: selectedRoleIds,
//       designation: designation.trim(),
//       documents: documents.filter((d) => d.doc_name || d.doc),
//       profile_fields: profileFields.filter(
//         (f) => f.field_name || f.field_particular,
//       ),
//     };

//     api
//       .patch(`/auth/role-mgmt/${selectedUser.id}/`, payload)
//       .then(() => {
//         showSnack("Updated successfully.", "success");
//         setOpenEditDialog(false);
//         fetchRoleMgmt();
//       })
//       .catch(() => showSnack("Failed to update.", "error"));
//   };

//   if (loading) return <Typography sx={{ p: 3 }}>Loading...</Typography>;

//   // ── render ───────────────────────────────────────────────────────────────────
//   return (
//     <Box
//       sx={{
//         width: "100%",
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         backgroundColor: "#fff",
//       }}
//     >
//       {/* Header */}
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         sx={{ backgroundColor: "rgba(195,234,203,0.1)", p: 2 }}
//       >
//         <Typography variant="h4" fontWeight="bold">
//           Admin Role Management
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort="true"
//       />

//       {/* ════════════════════════════════ VIEW DIALOG ═══════════════════════ */}
//       <Dialog
//         open={openViewDialog}
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>User Details — {viewUser?.name}</DialogTitle>
//         <DialogContent dividers>
//           <Typography variant="body2" color="text.secondary" gutterBottom>
//             {viewUser?.email}
//           </Typography>

//           <Tabs
//             value={viewTab}
//             onChange={(_, v) => setViewTab(v)}
//             sx={{ mb: 1 }}
//           >
//             <Tab label="Roles & Designation" />
//             <Tab label={`Documents (${viewUser?.documents?.length ?? 0})`} />
//             <Tab
//               label={`Extra Fields (${viewUser?.profileFields?.length ?? 0})`}
//             />
//           </Tabs>

//           {/* tab 0 – roles & designation */}
//           <TabPanel value={viewTab} index={0}>
//             <Typography variant="subtitle2" gutterBottom>
//               Roles
//             </Typography>
//             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 2 }}>
//               {viewUser?.roles?.length ? (
//                 viewUser.roles.map((r) => (
//                   <Chip key={r.id} label={r.name} size="small" />
//                 ))
//               ) : (
//                 <Typography variant="body2" color="text.secondary">
//                   No roles assigned.
//                 </Typography>
//               )}
//             </Box>
//             <Divider sx={{ my: 1 }} />
//             <Typography variant="subtitle2" gutterBottom>
//               Designation
//             </Typography>
//             <Typography variant="body2">
//               {viewUser?.designation || "—"}
//             </Typography>
//           </TabPanel>

//           {/* tab 1 – documents */}
//           <TabPanel value={viewTab} index={1}>
//             {viewUser?.documents?.length ? (
//               viewUser.documents.map((doc, i) => (
//                 <Box
//                   key={doc.id ?? i}
//                   sx={{
//                     mb: 2,
//                     p: 1.5,
//                     border: "1px solid #e0e0e0",
//                     borderRadius: 1,
//                   }}
//                 >
//                   <Typography variant="subtitle2">
//                     {doc.doc_name || "(no name)"}
//                   </Typography>
//                   {doc.doc &&
//                     (doc.doc.startsWith("data:image") ? (
//                       <Box
//                         component="img"
//                         src={doc.doc}
//                         alt={doc.doc_name}
//                         sx={{ maxWidth: "100%", mt: 1, borderRadius: 1 }}
//                       />
//                     ) : (
//                       <Button
//                         size="small"
//                         sx={{ mt: 1 }}
//                         variant="outlined"
//                         href={doc.doc}
//                         download={doc.doc_name || "document"}
//                       >
//                         Download
//                       </Button>
//                     ))}
//                 </Box>
//               ))
//             ) : (
//               <Typography variant="body2" color="text.secondary">
//                 No documents uploaded.
//               </Typography>
//             )}
//           </TabPanel>

//           {/* tab 2 – extra fields */}
//           <TabPanel value={viewTab} index={2}>
//             {viewUser?.profileFields?.length ? (
//               viewUser.profileFields.map((f, i) => (
//                 <Box
//                   key={f.id ?? i}
//                   sx={{
//                     mb: 1.5,
//                     p: 1.5,
//                     border: "1px solid #e0e0e0",
//                     borderRadius: 1,
//                   }}
//                 >
//                   <Typography variant="subtitle2">
//                     {f.field_name || "(no label)"}
//                   </Typography>
//                   <Typography variant="body2" sx={{ mt: 0.5 }}>
//                     {f.field_particular || "—"}
//                   </Typography>
//                 </Box>
//               ))
//             ) : (
//               <Typography variant="body2" color="text.secondary">
//                 No extra fields added.
//               </Typography>
//             )}
//           </TabPanel>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ════════════════════════════════ EDIT DIALOG ═══════════════════════ */}
//       <Dialog
//         open={openEditDialog}
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Edit — {selectedUser?.name}</DialogTitle>
//         <DialogContent dividers>
//           <Typography variant="body2" color="text.secondary" gutterBottom>
//             {selectedUser?.email}
//           </Typography>

//           <Tabs
//             value={editTab}
//             onChange={(_, v) => setEditTab(v)}
//             sx={{ mb: 1 }}
//           >
//             <Tab label="Roles & Designation" />
//             <Tab label="Documents" />
//             <Tab label="Extra Fields" />
//           </Tabs>

//           {/* ── tab 0: roles + designation ── */}
//           <TabPanel value={editTab} index={0}>
//             <FormControl fullWidth margin="dense">
//               <InputLabel id="roles-label">Select Roles</InputLabel>
//               <Select
//                 labelId="roles-label"
//                 multiple
//                 value={selectedRoleIds}
//                 onChange={(e) => setSelectedRoleIds(e.target.value)}
//                 label="Select Roles"
//                 renderValue={(selected) => (
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                     {selected.map((id) => (
//                       <Chip
//                         key={id}
//                         size="small"
//                         label={roles.find((r) => r.id === id)?.name ?? id}
//                       />
//                     ))}
//                   </Box>
//                 )}
//               >
//                 {roles.map((role) => (
//                   <MenuItem key={role.id} value={role.id}>
//                     {role.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <TextField
//               margin="dense"
//               label="Designation"
//               fullWidth
//               variant="outlined"
//               value={designation}
//               onChange={(e) => setDesignation(e.target.value)}
//               sx={{ mt: 2 }}
//             />
//           </TabPanel>

//           {/* ── tab 1: documents ── */}
//           <TabPanel value={editTab} index={1}>
//             {documents.map((doc, i) => (
//               <Box
//                 key={i}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   border: "1px solid #e0e0e0",
//                   borderRadius: 1,
//                 }}
//               >
//                 <Box
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                 >
//                   <Typography variant="subtitle2">Document {i + 1}</Typography>
//                   {documents.length > 1 && (
//                     <IconButton
//                       size="small"
//                       color="error"
//                       onClick={() => removeDoc(i)}
//                     >
//                       <Delete fontSize="small" />
//                     </IconButton>
//                   )}
//                 </Box>

//                 <TextField
//                   margin="dense"
//                   label="Document Name"
//                   fullWidth
//                   size="small"
//                   value={doc.doc_name}
//                   onChange={(e) =>
//                     handleDocChange(i, "doc_name", e.target.value)
//                   }
//                 />

//                 <Button
//                   variant="outlined"
//                   component="label"
//                   size="small"
//                   sx={{ mt: 1 }}
//                 >
//                   {doc.doc ? "Change File" : "Upload File"}
//                   <input
//                     type="file"
//                     hidden
//                     onChange={(e) => handleDocFile(i, e.target.files[0])}
//                   />
//                 </Button>

//                 {doc.doc && (
//                   <Typography
//                     variant="caption"
//                     display="block"
//                     sx={{ mt: 0.5 }}
//                     color="success.main"
//                   >
//                     {doc.doc.startsWith("data:image")
//                       ? "✓ Image ready"
//                       : "✓ File ready"}
//                   </Typography>
//                 )}
//               </Box>
//             ))}

//             <Button
//               startIcon={<Add />}
//               onClick={addDoc}
//               size="small"
//               variant="text"
//             >
//               Add Document
//             </Button>
//           </TabPanel>

//           {/* ── tab 2: extra profile fields ── */}
//           <TabPanel value={editTab} index={2}>
//             {profileFields.map((field, i) => (
//               <Box
//                 key={i}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   border: "1px solid #e0e0e0",
//                   borderRadius: 1,
//                 }}
//               >
//                 <Box
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                 >
//                   <Typography variant="subtitle2">Field {i + 1}</Typography>
//                   {profileFields.length > 1 && (
//                     <IconButton
//                       size="small"
//                       color="error"
//                       onClick={() => removeField(i)}
//                     >
//                       <Delete fontSize="small" />
//                     </IconButton>
//                   )}
//                 </Box>

//                 <TextField
//                   margin="dense"
//                   label="Field Label"
//                   fullWidth
//                   size="small"
//                   value={field.field_name}
//                   onChange={(e) =>
//                     handleFieldChange(i, "field_name", e.target.value)
//                   }
//                 />

//                 <TextField
//                   margin="dense"
//                   label="Value / Particular"
//                   fullWidth
//                   size="small"
//                   multiline
//                   rows={2}
//                   value={field.field_particular}
//                   onChange={(e) =>
//                     handleFieldChange(i, "field_particular", e.target.value)
//                   }
//                 />
//               </Box>
//             ))}

//             <Button
//               startIcon={<Add />}
//               onClick={addField}
//               size="small"
//               variant="text"
//             >
//               Add Field
//             </Button>
//           </TabPanel>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button onClick={handleUpdate} variant="contained" color="primary">
//             Update
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Chip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Divider,
  Tabs,
  Tab,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Edit, Visibility, Add, Delete } from "@mui/icons-material";
import TableComponent from "../../Components/TableComponent/TableComponent";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import api from "../../api/axiosInterceptor";


// ─── tiny tab-panel helper ────────────────────────────────────────────────────
function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
}


// ─── initial blank shapes ─────────────────────────────────────────────────────
const blankDoc = () => ({ doc_name: "", doc: "" });
const blankField = () => ({ field_name: "", field_particular: "" });


export const AdminRoleManagementComponent = () => {
  const [rows, setRows] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);


  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");


  // edit dialog
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [designation, setDesignation] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [documents, setDocuments] = useState([blankDoc()]);
  const [profileFields, setProfileFields] = useState([blankField()]);
  const [editTab, setEditTab] = useState(0);


  // view dialog
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewUser, setViewUser] = useState(null);
  const [viewTab, setViewTab] = useState(0);


  // ── columns ─────────────────────────────────────────────────────────────────
  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "name", field: "name", headerName: "Name", width: 200 },
    { id: "email", field: "email", headerName: "Email", width: 250 },
    {
      id: "phone_number",
      field: "phone_number",
      headerName: "Phone Number",
      width: 150,
    },
    {
      id: "roles",
      field: "roles",
      headerName: "Roles",
      width: 280,
      renderCell: (params) => (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {params.value.map((role) => (
            <Chip key={role.id} label={role.name} size="small" />
          ))}
        </Box>
      ),
    },
    {
      id: "designation",
      field: "designation",
      headerName: "Designation",
      width: 180,
      renderCell: (params) => (
        <Typography variant="body2">{params.value || "-"}</Typography>
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 130,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View details">
            <IconButton color="info" onClick={() => handleView(params.row)}>
              <Visibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => handleEdit(params.row)}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];


  // ── data fetching ────────────────────────────────────────────────────────────
  const fetchRoles = () => {
    api
      .get("/auth/roles/")
      .then((res) => setRoles(res.data))
      .catch(() => showSnack("Failed to load roles.", "error"));
  };


  const fetchRoleMgmt = () => {
    setLoading(true);
    api
      .get("/auth/role-mgmt/")
      .then((res) => {
        const apiData = res.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          name: item.name,
          email: item.email,
          phone_number: item.phone_number,
          roles: item.roles || [],
          designation: item.profile?.designation || "",
          is_active: item.is_active ?? false,
          documents: item.profile?.documents || [],
          profileFields: item.profile?.profile_fields || [],
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        showSnack("Failed to load user roles.", "error");
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchRoles();
    fetchRoleMgmt();
  }, []);


  // ── helpers ──────────────────────────────────────────────────────────────────
  const showSnack = (message, severity = "info") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };


  // ── view ─────────────────────────────────────────────────────────────────────
  const handleView = (user) => {
    setViewUser(user);
    setViewTab(0);
    setOpenViewDialog(true);
  };


  // ── edit ─────────────────────────────────────────────────────────────────────
  const handleEdit = (user) => {
    setSelectedUser(user);
    setSelectedRoleIds(user.roles.map((r) => r.id));
    setDesignation(user.designation || "");
    setIsActive(!!user.is_active);
    setDocuments(user.documents?.length ? user.documents : [blankDoc()]);
    setProfileFields(
      user.profileFields?.length ? user.profileFields : [blankField()],
    );
    setEditTab(0);
    setOpenEditDialog(true);
  };


  // ── document list helpers ────────────────────────────────────────────────────
  const handleDocChange = (index, field, value) => {
    setDocuments((prev) =>
      prev.map((d, i) => (i === index ? { ...d, [field]: value } : d)),
    );
  };
  const addDoc = () => setDocuments((prev) => [...prev, blankDoc()]);
  const removeDoc = (index) =>
    setDocuments((prev) => prev.filter((_, i) => i !== index));


  // file → base64
  const handleDocFile = (index, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => handleDocChange(index, "doc", e.target.result);
    reader.readAsDataURL(file);
  };


  // ── profile-field list helpers ───────────────────────────────────────────────
  const handleFieldChange = (index, key, value) => {
    setProfileFields((prev) =>
      prev.map((f, i) => (i === index ? { ...f, [key]: value } : f)),
    );
  };
  const addField = () => setProfileFields((prev) => [...prev, blankField()]);
  const removeField = (index) =>
    setProfileFields((prev) => prev.filter((_, i) => i !== index));


  // ── update ───────────────────────────────────────────────────────────────────
  const handleUpdate = () => {
    if (!selectedUser) return;


    const payload = {
      roles: selectedRoleIds,
      designation: designation.trim(),
      is_active: isActive,
      documents: documents.filter((d) => d.doc_name || d.doc),
      profile_fields: profileFields.filter(
        (f) => f.field_name || f.field_particular,
      ),
    };


    api
      .patch(`/auth/role-mgmt/${selectedUser.id}/`, payload)
      .then(() => {
        showSnack("Updated successfully.", "success");
        setOpenEditDialog(false);
        fetchRoleMgmt();
      })
      .catch(() => showSnack("Failed to update.", "error"));
  };


  if (loading) return <Typography sx={{ p: 3 }}>Loading...</Typography>;


  // ── render ───────────────────────────────────────────────────────────────────
  return (
    <Box
      sx={{
        width: "100%",
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ backgroundColor: "rgba(195,234,203,0.1)", p: 2 }}
      >
        <Typography variant="h4" fontWeight="bold">
          Admin Role Management
        </Typography>
      </Box>


      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort="true"
      />


      {/* ════════════════════════════════ VIEW DIALOG ═══════════════════════════════ */}
      <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>User Details — {viewUser?.name}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {viewUser?.email}
          </Typography>


          <Tabs
            value={viewTab}
            onChange={(_, v) => setViewTab(v)}
            sx={{ mb: 1 }}
          >
            <Tab label="Roles & Designation" />
            <Tab label={`Documents (${viewUser?.documents?.length ?? 0})`} />
            <Tab
              label={`Extra Fields (${viewUser?.profileFields?.length ?? 0})`}
            />
          </Tabs>


          <TabPanel value={viewTab} index={0}>
            <Typography variant="subtitle2" gutterBottom>
              Roles
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 2 }}>
              {viewUser?.roles?.length ? (
                viewUser.roles.map((r) => (
                  <Chip key={r.id} label={r.name} size="small" />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No roles assigned.
                </Typography>
              )}
            </Box>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2" gutterBottom>
              Designation
            </Typography>
            <Typography variant="body2">
              {viewUser?.designation || "—"}
            </Typography>
          </TabPanel>


          <TabPanel value={viewTab} index={1}>
            {viewUser?.documents?.length ? (
              viewUser.documents.map((doc, i) => (
                <Box
                  key={doc.id ?? i}
                  sx={{
                    mb: 2,
                    p: 1.5,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2">
                    {doc.doc_name || "(no name)"}
                  </Typography>
                  {doc.doc &&
                    (doc.doc.startsWith("data:image") ? (
                      <Box
                        component="img"
                        src={doc.doc}
                        alt={doc.doc_name}
                        sx={{ maxWidth: "100%", mt: 1, borderRadius: 1 }}
                      />
                    ) : (
                      <Button
                        size="small"
                        sx={{ mt: 1 }}
                        variant="outlined"
                        href={doc.doc}
                        download={doc.doc_name || "document"}
                      >
                        Download
                      </Button>
                    ))}
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No documents uploaded.
              </Typography>
            )}
          </TabPanel>


          <TabPanel value={viewTab} index={2}>
            {viewUser?.profileFields?.length ? (
              viewUser.profileFields.map((f, i) => (
                <Box
                  key={f.id ?? i}
                  sx={{
                    mb: 1.5,
                    p: 1.5,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2">
                    {f.field_name || "(no label)"}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {f.field_particular || "—"}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No extra fields added.
              </Typography>
            )}
          </TabPanel>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* ════════════════════════════════ EDIT DIALOG ═══════════════════════════════ */}
      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit — {selectedUser?.name}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {selectedUser?.email}
          </Typography>


          <Tabs
            value={editTab}
            onChange={(_, v) => setEditTab(v)}
            sx={{ mb: 1 }}
          >
            <Tab label="Roles & Designation" />
            <Tab label="Documents" />
            <Tab label="Extra Fields" />
          </Tabs>


          <TabPanel value={editTab} index={0}>
            <FormControl fullWidth margin="dense">
              <InputLabel id="roles-label">Select Roles</InputLabel>
              <Select
                labelId="roles-label"
                multiple
                value={selectedRoleIds}
                onChange={(e) => setSelectedRoleIds(e.target.value)}
                label="Select Roles"
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => (
                      <Chip
                        key={id}
                        size="small"
                        label={roles.find((r) => r.id === id)?.name ?? id}
                      />
                    ))}
                  </Box>
                )}
              >
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>


            <TextField
              margin="dense"
              label="Designation"
              fullWidth
              variant="outlined"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              sx={{ mt: 2 }}
            />

            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              }
              label="Is Active"
            />
          </TabPanel>


          <TabPanel value={editTab} index={1}>
            {documents.map((doc, i) => (
              <Box
                key={i}
                sx={{
                  mb: 2,
                  p: 1.5,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="subtitle2">Document {i + 1}</Typography>
                  {documents.length > 1 && (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => removeDoc(i)}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  )}
                </Box>


                <TextField
                  margin="dense"
                  label="Document Name"
                  fullWidth
                  size="small"
                  value={doc.doc_name}
                  onChange={(e) =>
                    handleDocChange(i, "doc_name", e.target.value)
                  }
                />


                <Button
                  variant="outlined"
                  component="label"
                  size="small"
                  sx={{ mt: 1 }}
                >
                  {doc.doc ? "Change File" : "Upload File"}
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleDocFile(i, e.target.files[0])}
                  />
                </Button>


                {doc.doc && (
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ mt: 0.5 }}
                    color="success.main"
                  >
                    {doc.doc.startsWith("data:image")
                      ? "✓ Image ready"
                      : "✓ File ready"}
                  </Typography>
                )}
              </Box>
            ))}


            <Button
              startIcon={<Add />}
              onClick={addDoc}
              size="small"
              variant="text"
            >
              Add Document
            </Button>
          </TabPanel>


          <TabPanel value={editTab} index={2}>
            {profileFields.map((field, i) => (
              <Box
                key={i}
                sx={{
                  mb: 2,
                  p: 1.5,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="subtitle2">Field {i + 1}</Typography>
                  {profileFields.length > 1 && (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => removeField(i)}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  )}
                </Box>


                <TextField
                  margin="dense"
                  label="Field Label"
                  fullWidth
                  size="small"
                  value={field.field_name}
                  onChange={(e) =>
                    handleFieldChange(i, "field_name", e.target.value)
                  }
                />


                <TextField
                  margin="dense"
                  label="Value / Particular"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  value={field.field_particular}
                  onChange={(e) =>
                    handleFieldChange(i, "field_particular", e.target.value)
                  }
                />
              </Box>
            ))}


            <Button
              startIcon={<Add />}
              onClick={addField}
              size="small"
              variant="text"
            >
              Add Field
            </Button>
          </TabPanel>
        </DialogContent>


        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>


      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};
